const NEW = 0;
const DRAFT = 10;
const SUCCESS = 20;
const ERROR = 30;

export default {
  SUCCESS,
  NEW,
  DRAFT,
  ERROR,
};
